import { Fragment } from "react";
import Typography from "@material-ui/core/Typography";

import { Input } from "../../shared/components/FormElements/Input";
import { InputPhone } from "../../shared/components/FormElements/InputPhone";
import { InputSelectRequired } from "../../shared/components/FormElements/InputSelectRequired";
import { InputDefined } from "../../shared/components/FormElements/InputDefined";
import { InputAutocompleteCityRequired } from "../../shared/components/FormElements/InputAutocompleteCityRequired";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_MINLENGTH,
} from "../../shared/util/validators";
import { UF } from "../../shared/data/static";
import {
  FormHookDispState,
  PlaceData,
  SettingData,
} from "../../shared/data/types";

import { ProposalStepOneEditStyles } from "../../proposal/pages/ProposalStepOneEditStyles";

interface InputsSimFormCustomerDataProps {
  inputHandler: (
    id: string,
    value: string | boolean | File,
    isValid: boolean,
    label: string
  ) => void;
  formState: FormHookDispState;
  chosenCoordinates: {
    lat: string;
    lng: string;
  };
  loadedPlaces: PlaceData[];
  setLoadedPlaces: React.Dispatch<React.SetStateAction<PlaceData[]>>;
}

export const InputsSimFormCustomerData = (
  props: InputsSimFormCustomerDataProps
) => {
  const {
    inputHandler,
    formState,
    chosenCoordinates,
    loadedPlaces,
    setLoadedPlaces,
  } = props;
  const classes = ProposalStepOneEditStyles();

  return (
    <Fragment>
      {/* <Typography
        style={{ color: colors.light }}
        className={classes.titleSummaryze}
        variant="h6"
      >
        Dados do Responsável
      </Typography> */}
      <div className="form-inputs-grid-1fr-1fr form-inputs-grid-responsive">
        <Input
          isName
          forceUpperCase
          id="name"
          label="nome"
          variant="outlined"
          type="text"
          onInput={inputHandler}
          validators={[VALIDATOR_REQUIRE()]}
          helperText="Informe o seu nome."
          initialValue=""
          forceError={formState?.inputs?.name?.forceError}
          reinitialize
        />
        <InputPhone
          id="phone"
          type="text"
          label="celular"
          variant="outlined"
          validators={[VALIDATOR_MINLENGTH(10)]}
          helperText="Informe o seu celular."
          onInput={inputHandler}
          reset={formState?.reset}
          forceError={formState?.inputs?.phone?.forceError}
          initialValue=""
          reinitialize
        />
      </div>
      <div className="form-inputs-grid-70px-1fr">
        <InputSelectRequired
          id="uf"
          label="UF"
          onInput={inputHandler}
          options={UF}
          initialValue=""
          disabled={
            formState.inputs?.city?.value &&
            formState.inputs?.city?.value.toString().length > 0
              ? true
              : false
          }
          variant={
            formState.inputs?.city?.value &&
            formState.inputs?.city?.value.toString().length > 0
              ? "filled"
              : "standard"
          }
          forceError={formState?.inputs?.uf?.forceError}
          updateInitValue
        />
        <InputAutocompleteCityRequired
          disabled={!formState.inputs?.uf?.value}
          // options={loadedPlaces || []}
          setLoadedPlaces={setLoadedPlaces}
          uf={formState.inputs?.uf?.value.toString().toLowerCase()}
          id="city"
          label="cidade"
          variant="outlined"
          helperText="Informe qual a sua cidade."
          onInput={inputHandler}
          initialValue=""
          forceError={formState?.inputs?.city?.forceError}
          updateInitValue
        />
      </div>
      <div style={{ display: "none" }} className="form-inputs-grid-1fr-1fr">
        <InputDefined
          disabled={true}
          initialValue={chosenCoordinates.lat}
          id="lat"
          type="text"
          label="latitude"
          variant="filled"
          validators={[VALIDATOR_REQUIRE()]}
          onInput={inputHandler}
        />
        <InputDefined
          disabled={true}
          initialValue={chosenCoordinates.lng}
          id="lng"
          type="text"
          label="longitude"
          variant="filled"
          validators={[VALIDATOR_REQUIRE()]}
          onInput={inputHandler}
        />
      </div>
    </Fragment>
  );
};
